export default __webpack_public_path__ + "static/media/98C94562-8369-4751-85D2-D160459195FE_1_105_c.ca651ef3.jpeg";